import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1328df89&scoped=true"
import script from "./billingInvoices.js?vue&type=script&lang=js&external"
export * from "./billingInvoices.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=1328df89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328df89",
  null
  
)

export default component.exports